import React from 'react';
import './chapters.scss';
import InlinePhotos from '../InlinePhotos/InlinePhotos';
import inlineD from '../../assets/image1-l.jpg';
import inlineM from '../../assets/image1-s.jpg';
import Quote from '../Quote/Quote';
import quotePhoto from '../../assets/jack.jpg';

function Chapter1() {
  const inlinePhotoData = {
    srcD: inlineD,
    srcM: inlineM
  };
  const quoteData = {
    photo: quotePhoto,
    copy: '“[The modern vehicle] is fundamentally changing from a mechanical device with embedded compute systems distributed around the car to a vehicle platform built around a high-performance computer.”',
    author: 'Jack Weast',
    title: 'VP & General Manager, Intel Automotive'
  };
  return (
    <section className="chapters">
      <InlinePhotos data={inlinePhotoData} />
      <div className="chapters__copy">
        <h3>Chips in Cars: A Brief History</h3>
        <p>
          Semiconductor technology is not exactly new to cars. Since the late 1960s, automakers have
          incorporated computer chips to monitor and control fuel injection systems, resulting in
          more efficient engines that gave off fewer emissions. Intel entered the automotive market
          in 1976 with its first engine control units (ECUs) and was soon creating custom ECUs for
          industry partners.
        </p>
        <p>
          In the decades that followed, adding new features meant adding new microcontrollers. Chips
          moved beyond emissions control to assist in everything from airbags and anti-lock braking
          systems (ABS) to windshield wipers and traction control systems (TCS).
        </p>
        <p>
          According to Jack Weast, Vice President and General Manager of Intel Automotive, “These 8-
          or 16-bit chips would typically perform just a single function and that’s it.” The result,
          Weast says, is that today’s internal combustion vehicles frequently have “over 100
          embedded micro-controllers, each doing one function with no re-use or interoperability
          between each of the individual chips.”
        </p>
        <p>
          By the 2010s, 32-bit, multicore MCUs enabled a host of new features, including advanced
          driver assistance, navigation systems, wireless integration, and infotainment systems. In
          recent years, a new generation of battery electric vehicles (BEVs) have incorporated
          64-bit chips with AI engines, giving a more visible and prominent role to semiconductors
          in the car’s core functions and driving experience. Even as we move away from internal
          combustion engine vehicles (ICEs) to BEVs, achieving the car of the future is not simply a
          matter of adding more—or more powerful—processors. “This historical ‘distributed’
          architecture has finally hit a wall,” Weast says.
        </p>
        <p>The solution involves nothing less than reengineering vehicles from the ground up.</p>
        <Quote data={quoteData} />
      </div>
    </section>
  );
}

export default Chapter1;
